import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		background: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		padding: spacing.lg,
	},
	headerRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'baseline',
		gap: spacing.md,
		flexWrap: 'wrap',
	},
	titleRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	titleIcon: {
		color: colors.primary.main,
		flexShrink: 0,
	},
	title: {
		fontFamily: typography.fontFamilies.sora,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		color: colors.text.main,
		margin: 0,
	},
	controlsRow: {
		display: 'flex',
		gap: spacing.md,
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	searchInput: {
		flex: 1,
		minWidth: 280,
		maxWidth: 480,
	},
	filterGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
		fontSize: typography.fontSizes.sm,
		color: colors.text.light,
	},
	tableWrap: {
		overflowX: 'auto',
		border: common.border,
		borderRadius: common.borderRadius,
	},
	table: {
		width: '100%',
		borderCollapse: 'collapse',
		fontSize: typography.fontSizes.sm,
	},
	th: {
		textAlign: 'left',
		padding: `${spacing.sm}px ${spacing.md}px`,
		// `hover.light` is the documented THEME token for table headers (per the
		// theme palette comments on packages/main/app/web/components-v2/Theme/theme.ts).
		background: colors.hover.light,
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		letterSpacing: 0.5,
		textTransform: 'uppercase',
		borderBottom: common.border,
		whiteSpace: 'nowrap',
	},
	td: {
		padding: `${spacing.md}px ${spacing.md}px`,
		borderBottom: `1px solid ${colors.border.light}`,
		color: colors.text.main,
		verticalAlign: 'top',
	},
	nameCell: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		minWidth: 180,
	},
	accountName: {
		fontWeight: typography.fontWeights.semibold,
	},
	accountId: {
		fontFamily: 'monospace',
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
	},
	assignedCell: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		minWidth: 220,
	},
	assignedLine: {
		display: 'flex',
		gap: spacing.xs,
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	assignedAccountLink: {
		color: colors.primary.main,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
	assignedRole: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	unassigned: {
		color: colors.text.light,
	},
	editButton: {
		// Aligned-left, padding-less override applied to the `link` Button variant
		// so it reads as an inline link inside the table cell.
		padding: 0,
		justifyContent: 'flex-start',
		fontSize: typography.fontSizes.sm,
		minHeight: 'auto',
	},
	assignedAccountGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: spacing.md,
		flexWrap: 'wrap',
	},
	resultsCount: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
	},
	emptyState: {
		padding: spacing.xxl,
		textAlign: 'center',
		color: colors.text.light,
	},
	skeletonRow: {
		height: 48,
		background: colors.background.main,
		borderBottom: `1px solid ${colors.border.light}`,
	},
});
